export default __webpack_public_path__ + "static/media/Inter-Italic.d3b5fcca.woff";